// // src/pages/orders/OrderDetailsPage.jsx
// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate, Link } from 'react-router-dom';
// import DashboardLayout from '../../components/layout/DashboardLayout';
// import Button from '../../components/common/Button';
// import { useAuth } from '../../contexts/AuthContext';
// import { useNotification } from '../../contexts/NotificationContext';
// import { getOrderById, updateOrderStatus, generateInvoice } from '../../services/orderService';

// const OrderDetailsPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const { vendorProfile } = useAuth();
//   const { showAlert } = useNotification();
  
//   const [order, setOrder] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [showStatusModal, setShowStatusModal] = useState(false);
//   const [newStatus, setNewStatus] = useState('');
//   const [statusNote, setStatusNote] = useState('');
//   const [generatingInvoice, setGeneratingInvoice] = useState(false);
  
//   // Load order
//   useEffect(() => {
//     const loadOrder = async () => {
//       try {
//         if (!id) return;
        
//         setLoading(true);
//         setError('');
        
//         const result = await getOrderById(id);
//         setOrder(result);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error loading order:', error);
//         setError('Failed to load order. Please try again.');
//         setLoading(false);
//       }
//     };
    
//     loadOrder();
//   }, [id]);
  
//   // Format currency
//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       maximumFractionDigits: 0
//     }).format(amount);
//   };
  
//   // Format date
//   const formatDate = (timestamp) => {
//     if (!timestamp) return 'N/A';
    
//     // If already a string, return as is
//     if (typeof timestamp === 'string') return timestamp;
    
//     // Convert Firestore Timestamp to JavaScript Date
//     const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    
//     return date.toLocaleDateString('en-IN', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };
  
//   // Get status badge
//   const getStatusBadge = (status) => {
//     const statusClasses = {
//       Pending: 'bg-yellow-100 text-yellow-800',
//       Confirmed: 'bg-orange-100 text-orange-800',
//       Processing: 'bg-purple-100 text-purple-800',
//       Shipped: 'bg-indigo-100 text-indigo-800',
//       Delivered: 'bg-green-100 text-green-800',
//       Cancelled: 'bg-red-100 text-red-800',
//     };
    
//     return (
//       <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium ${statusClasses[status] || 'bg-gray-100 text-gray-800'}`}>
//         {status}
//       </span>
//     );
//   };
  
//   // Get next possible statuses
//   const getNextStatuses = (currentStatus) => {
//     switch (currentStatus) {
//       case 'Pending':
//         return ['Confirmed', 'Cancelled'];
//       case 'Confirmed':
//         return ['Processing', 'Cancelled'];
//       case 'Processing':
//         return ['Shipped', 'Cancelled'];
//       case 'Shipped':
//         return ['Delivered', 'Cancelled'];
//       case 'Delivered':
//         return [];
//       case 'Cancelled':
//         return [];
//       default:
//         return ['Pending', 'Confirmed', 'Processing', 'Shipped', 'Delivered', 'Cancelled'];
//     }
//   };
  
//   // Open status update modal
//   const openStatusModal = (status) => {
//     setNewStatus(status);
//     setStatusNote('');
//     setShowStatusModal(true);
//   };
  
//   // Close status update modal
//   const closeStatusModal = () => {
//     setShowStatusModal(false);
//     setNewStatus('');
//     setStatusNote('');
//   };
  
//   // Handle status update
//   const handleStatusUpdate = async () => {
//     try {
//       if (!order || !newStatus) return;
      
//       await updateOrderStatus(order.id, newStatus, { note: statusNote });
      
//       // Update order in state
//       setOrder(prev => ({
//         ...prev,
//         status: newStatus,
//         statusHistory: [
//           ...(prev.statusHistory || []),
//           {
//             status: newStatus,
//             timestamp: new Date(),
//             note: statusNote
//           }
//         ]
//       }));
      
//       showAlert(`Order status updated to ${newStatus}`, 'success');
//       closeStatusModal();
//     } catch (error) {
//       console.error('Error updating order status:', error);
//       showAlert('Failed to update order status', 'error');
//     }
//   };
  
//   // Handle invoice generation
//   const handleGenerateInvoice = async () => {
//     try {
//       if (!order) return;
      
//       setGeneratingInvoice(true);
      
//       const invoice = await generateInvoice(order.id);
      
//       // Update order in state
//       setOrder(prev => ({
//         ...prev,
//         invoice
//       }));
      
//       showAlert('Invoice generated successfully', 'success');
//       setGeneratingInvoice(false);
//     } catch (error) {
//       console.error('Error generating invoice:', error);
//       showAlert('Failed to generate invoice', 'error');
//       setGeneratingInvoice(false);
//     }
//   };
  
//   // Loading state
//   if (loading) {
//     return (
//       <DashboardLayout>
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
//           <div className="flex justify-center">
//             <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600"></div>
//           </div>
//           <p className="text-center mt-4 text-gray-500">Loading order details...</p>
//         </div>
//       </DashboardLayout>
//     );
//   }
  
//   // Error state
//   if (error || !order) {
//     return (
//       <DashboardLayout>
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
//           <div className="bg-red-50 border border-red-200 p-4 rounded-md">
//             <div className="flex">
//               <div className="flex-shrink-0">
//                 <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
//                   <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
//                 </svg>
//               </div>
//               <div className="ml-3">
//                 <h3 className="text-sm font-medium text-red-800">{error || 'Order not found'}</h3>
//                 <div className="mt-2 text-sm text-red-700">
//                   <p>Please try again or go back to the orders page.</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="mt-6">
//             <Button
//               type="button"
//               variant="primary"
//               onClick={() => navigate('/orders')}
//             >
//               Back to Orders
//             </Button>
//           </div>
//         </div>
//       </DashboardLayout>
//     );
//   }
  
//   return (
//     <DashboardLayout>
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
//         {/* Order Header */}
//         <div className="sm:flex sm:items-center sm:justify-between mb-6">
//           <div>
//             <h1 className="text-2xl font-bold text-gray-900">
//               Order #{order.id}
//             </h1>
//             <p className="mt-1 text-sm text-gray-500">
//               Placed on {formatDate(order.createdAt)}
//             </p>
//           </div>
//           <div className="mt-4 sm:mt-0 flex flex-wrap space-x-3">
//             {/* Invoice Button */}
//             {order.status !== 'Cancelled' && (
//               <Button
//                 type="button"
//                 variant="secondary"
//                 onClick={handleGenerateInvoice}
//                 disabled={generatingInvoice || (order.status === 'Pending')}
//               >
//                 {generatingInvoice ? (
//                   <div className="flex items-center">
//                     <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                       <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                       <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
//                     </svg>
//                     Generating...
//                   </div>
//                 ) : order.invoice ? (
//                   <div className="flex items-center">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
//                       <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z" clipRule="evenodd" />
//                     </svg>
//                     View Invoice
//                   </div>
//                 ) : (
//                   <div className="flex items-center">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
//                       <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 01-1-1V8a1 1 0 112 0v3a1 1 0 01-1 1zm3-1V8a1 1 0 10-2 0v3a1 1 0 102 0zm2-3a1 1 0 011 1v3a1 1 0 11-2 0V9a1 1 0 011-1z" clipRule="evenodd" />
//                     </svg>
//                     Generate Invoice
//                   </div>
//                 )}
//               </Button>
//             )}
            
//             {/* Status Update Button */}
//             {getNextStatuses(order.status).length > 0 && (
//               <div className="relative">
//                 <select
//                   className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm rounded-md"
//                   value=""
//                   onChange={(e) => {
//                     if (e.target.value) {
//                       openStatusModal(e.target.value);
//                       e.target.value = '';
//                     }
//                   }}
//                 >
//                   <option value="">Update Status</option>
//                   {getNextStatuses(order.status).map((status) => (
//                     <option key={status} value={status}>
//                       {status}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             )}
//           </div>
//         </div>
        
//         {/* Order Status */}
//         <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-6">
//           <div className="px-4 py-5 sm:px-6">
//             <h2 className="text-lg leading-6 font-medium text-gray-900">
//               Order Status
//             </h2>
//             <p className="mt-1 max-w-2xl text-sm text-gray-500">
//               Current status and history
//             </p>
//           </div>
//           <div className="border-t border-gray-200 px-4 py-5 sm:p-6">
//             <div className="mb-4">
//               <span className="text-sm font-medium text-gray-500">Current Status:</span>
//               <div className="mt-1">
//                 {getStatusBadge(order.status || 'Pending')}
//               </div>
//             </div>
            
//             {order.statusHistory && order.statusHistory.length > 0 && (
//               <div>
//                 <h3 className="text-sm font-medium text-gray-500 mb-2">Status History:</h3>
//                 <div className="flow-root">
//                   <ul className="-mb-8">
//                     {[...order.statusHistory].reverse().map((statusChange, index) => (
//                       <li key={index}>
//                         <div className="relative pb-8">
//                           {index !== order.statusHistory.length - 1 ? (
//                             <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
//                           ) : null}
//                           <div className="relative flex space-x-3">
//                             <div>
//                               <span className="h-8 w-8 rounded-full bg-orange-500 flex items-center justify-center ring-8 ring-white">
//                                 <svg className="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
//                                   <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//                                 </svg>
//                               </span>
//                             </div>
//                             <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
//                               <div>
//                                 <p className="text-sm text-gray-500">
//                                   Status changed to <span className="font-medium text-gray-900">{statusChange.status}</span>
//                                 </p>
//                                 {statusChange.note && (
//                                   <p className="mt-1 text-sm text-gray-500">
//                                     Note: {statusChange.note}
//                                   </p>
//                                 )}
//                               </div>
//                               <div className="text-right text-sm whitespace-nowrap text-gray-500">
//                                 {formatDate(statusChange.timestamp)}
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
        
//         {/* Order Details */}
//         <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-6">
//           <div className="px-4 py-5 sm:px-6">
//             <h2 className="text-lg leading-6 font-medium text-gray-900">
//               Order Details
//             </h2>
//             <p className="mt-1 max-w-2xl text-sm text-gray-500">
//               Order information and summary
//             </p>
//           </div>
//           <div className="border-t border-gray-200">
//             <dl>
//               <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//                 <dt className="text-sm font-medium text-gray-500">Order ID</dt>
//                 <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{order.id}</dd>
//               </div>
//               <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//                 <dt className="text-sm font-medium text-gray-500">Order Date</dt>
//                 <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{formatDate(order.createdAt)}</dd>
//               </div>
//               <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//                 <dt className="text-sm font-medium text-gray-500">Customer Name</dt>
//                 <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{order.customerName || 'N/A'}</dd>
//               </div>
//               <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//                 <dt className="text-sm font-medium text-gray-500">Customer Email</dt>
//                 <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{order.customerEmail || 'N/A'}</dd>
//               </div>
//               <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//                 <dt className="text-sm font-medium text-gray-500">Customer Phone</dt>
//                 <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{order.customerPhone || 'N/A'}</dd>
//               </div>
//               <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//                 <dt className="text-sm font-medium text-gray-500">Shipping Address</dt>
//                 <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
//                   {order.shippingAddress ? (
//                     <div>
//                       <p>{order.shippingAddress.street}</p>
//                       <p>{order.shippingAddress.city}, {order.shippingAddress.state} {order.shippingAddress.zip}</p>
//                       <p>{order.shippingAddress.country}</p>
//                     </div>
//                   ) : (
//                     'N/A'
//                   )}
//                 </dd>
//               </div>
//               <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//                 <dt className="text-sm font-medium text-gray-500">Payment Method</dt>
//                 <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{order.paymentMethod || 'N/A'}</dd>
//               </div>
//               {order.invoice && (
//                 <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
//                   <dt className="text-sm font-medium text-gray-500">Invoice</dt>
//                   <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
//                     <span className="font-medium">{order.invoice.invoiceNumber}</span>
//                     <span className="ml-2 text-gray-500">Generated on {formatDate(order.invoice.createdAt)}</span>
//                   </dd>
//                 </div>
//               )}
//             </dl>
//           </div>
//         </div>
        
//         {/* Order Items */}
//         <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-6">
//           <div className="px-4 py-5 sm:px-6">
//             <h2 className="text-lg leading-6 font-medium text-gray-900">
//               Order Items
//             </h2>
//             <p className="mt-1 max-w-2xl text-sm text-gray-500">
//               Products purchased in this order
//             </p>
//           </div>
//           <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
//             <div className="overflow-x-auto">
//               <table className="min-w-full divide-y divide-gray-200">
//                 <thead className="bg-gray-50">
//                   <tr>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Product
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Quantity
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Price
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Total
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody className="bg-white divide-y divide-gray-200">
//                   {order.items && order.items.length > 0 ? (
//                     order.items.map((item, index) => (
//                       <tr key={index}>
//                         <td className="px-6 py-4 whitespace-nowrap">
//                           <div className="flex items-center">
//                             <div className="flex-shrink-0 h-10 w-10">
//                               {item.imageUrl ? (
//                                 <img 
//                                   className="h-10 w-10 rounded-full" 
//                                   src={item.imageUrl} 
//                                   alt={item.name} 
//                                 />
//                               ) : (
//                                 <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center">
//                                   <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
//                                   </svg>
//                                 </div>
//                               )}
//                             </div>
//                             <div className="ml-4">
//                               <div className="text-sm font-medium text-gray-900">
//                                 {item.name}
//                               </div>
//                               <div className="text-sm text-gray-500">
//                                 {item.productId}
//                               </div>
//                             </div>
//                           </div>
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                           {item.quantity}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                           {formatCurrency(item.price)}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                           {formatCurrency(item.quantity * item.price)}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="4" className="px-6 py-4 text-center text-sm text-gray-500">
//                         No items found for this order.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
            
//             {/* Order Summary */}
//             <div className="border-t border-gray-200 px-4 py-5">
//               <div className="flex justify-end">
//                 <div className="w-full sm:w-1/3">
//                   <div className="flex justify-between py-2">
//                     <div className="text-sm text-gray-500">Subtotal</div>
//                     <div className="text-sm font-medium text-gray-900">{formatCurrency(order.subtotal || 0)}</div>
//                   </div>
//                   <div className="flex justify-between py-2">
//                     <div className="text-sm text-gray-500">Tax</div>
//                     <div className="text-sm font-medium text-gray-900">{formatCurrency(order.tax || 0)}</div>
//                   </div>
//                   <div className="flex justify-between py-2">
//                     <div className="text-sm text-gray-500">Shipping</div>
//                     <div className="text-sm font-medium text-gray-900">{formatCurrency(order.shipping || 0)}</div>
//                   </div>
//                   <div className="flex justify-between py-2 border-t border-gray-200">
//                     <div className="text-base font-medium text-gray-900">Total</div>
//                     <div className="text-base font-medium text-gray-900">{formatCurrency(order.total || 0)}</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
        
//         {/* Back Button */}
//         <div className="mt-8">
//           <Button
//             type="button"
//             variant="secondary"
//             onClick={() => navigate('/orders')}
//           >
//             Back to Orders
//           </Button>
//         </div>
//       </div>
      
//       {/* Status Update Modal */}
//       {showStatusModal && (
//         <div className="fixed z-10 inset-0 overflow-y-auto">
//           <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
//             <div className="fixed inset-0 transition-opacity" aria-hidden="true">
//               <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
//             </div>
            
//             <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            
//             <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
//               <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
//                 <div className="sm:flex sm:items-start">
//                   <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-orange-100 sm:mx-0 sm:h-10 sm:w-10">
//                     <svg className="h-6 w-6 text-orange-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//                     </svg>
//                   </div>
//                   <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
//                     <h3 className="text-lg leading-6 font-medium text-gray-900">
//                       Update Order Status
//                     </h3>
//                     <div className="mt-2">
//                       <p className="text-sm text-gray-500">
//                         Update the status of order <span className="font-medium">#{order.id}</span> from <span className="font-medium">{order.status}</span> to <span className="font-medium">{newStatus}</span>.
//                       </p>
                      
//                       <div className="mt-4">
//                         <label htmlFor="statusNote" className="block text-sm font-medium text-gray-700">
//                           Add a note (optional)
//                         </label>
//                         <textarea
//                           id="statusNote"
//                           rows={3}
//                           className="mt-1 block w-full shadow-sm focus:ring-orange-500 focus:border-orange-500 sm:text-sm border border-gray-300 rounded-md"
//                           placeholder="Enter any additional information about this status change..."
//                           value={statusNote}
//                           onChange={(e) => setStatusNote(e.target.value)}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
//                 <button
//                   type="button"
//                   className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-orange-600 text-base font-medium text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:ml-3 sm:w-auto sm:text-sm"
//                   onClick={handleStatusUpdate}
//                 >
//                   Update Status
//                 </button>
//                 <button
//                   type="button"
//                   className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
//                   onClick={closeStatusModal}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </DashboardLayout>
//   );
// };

// export default OrderDetailsPage;
// src/pages/orders/OrderDetailsPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import Button from '../../components/common/Button';
import PorterDispatch from '../../components/porter/PorterDispatch';
import { useAuth } from '../../contexts/AuthContext';
import { useNotification } from '../../contexts/NotificationContext';
import { getOrderById, updateOrderStatus, generateInvoice } from '../../services/orderService';
import { trackPorterOrder } from '../../services/porterService';

const OrderDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { vendorProfile } = useAuth();
  const { showAlert } = useNotification();
  
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [newStatus, setNewStatus] = useState('');
  const [statusNote, setStatusNote] = useState('');
  const [generatingInvoice, setGeneratingInvoice] = useState(false);
  const [porterDelivery, setPorterDelivery] = useState(null);
  const [trackingPorterDelivery, setTrackingPorterDelivery] = useState(false);
  
  // Load order
  useEffect(() => {
    const loadOrder = async () => {
      try {
        if (!id) return;
        
        setLoading(true);
        setError('');
        
        const result = await getOrderById(id);
        setOrder(result);
        
        // Check if the order has a Porter delivery ID
        if (result.porterDeliveryId) {
          await fetchPorterDeliveryStatus(result.porterDeliveryId);
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Error loading order:', error);
        setError('Failed to load order. Please try again.');
        setLoading(false);
      }
    };
    
    loadOrder();
  }, [id]);
  
  // Fetch Porter delivery status
  const fetchPorterDeliveryStatus = async (porterOrderId) => {
    try {
      setTrackingPorterDelivery(true);
      const deliveryStatus = await trackPorterOrder(porterOrderId);
      setPorterDelivery(deliveryStatus);
      setTrackingPorterDelivery(false);
    } catch (error) {
      console.error('Error fetching Porter delivery status:', error);
      setTrackingPorterDelivery(false);
    }
  };
  
  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  };
  
  // Format date
  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    
    // If already a string, return as is
    if (typeof timestamp === 'string') return timestamp;
    
    // Convert Firestore Timestamp to JavaScript Date
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    
    return date.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  
  // Get status badge
  const getStatusBadge = (status) => {
    const statusClasses = {
      Pending: 'bg-yellow-100 text-yellow-800',
      Confirmed: 'bg-orange-100 text-orange-800',
      Processing: 'bg-purple-100 text-purple-800',
      Shipped: 'bg-indigo-100 text-indigo-800',
      Delivered: 'bg-green-100 text-green-800',
      Cancelled: 'bg-red-100 text-red-800',
    };
    
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium ${statusClasses[status] || 'bg-gray-100 text-gray-800'}`}>
        {status}
      </span>
    );
  };
  
  // Get Porter status badge
  const getPorterStatusBadge = (status) => {
    const statusClasses = {
      open: 'bg-yellow-100 text-yellow-800',
      accepted: 'bg-orange-100 text-orange-800',
      live: 'bg-blue-100 text-blue-800',
      ended: 'bg-green-100 text-green-800',
      cancelled: 'bg-red-100 text-red-800',
      order_reopened: 'bg-purple-100 text-purple-800'
    };
    
    const statusLabels = {
      open: 'Open',
      accepted: 'Accepted',
      live: 'In Transit',
      ended: 'Delivered',
      cancelled: 'Cancelled',
      order_reopened: 'Reopened'
    };
    
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium ${statusClasses[status] || 'bg-gray-100 text-gray-800'}`}>
        {statusLabels[status] || status}
      </span>
    );
  };
  
  // Get next possible statuses
  const getNextStatuses = (currentStatus) => {
    switch (currentStatus) {
      case 'Pending':
        return ['Confirmed', 'Cancelled'];
      case 'Confirmed':
        return ['Processing', 'Cancelled'];
      case 'Processing':
        return ['Shipped', 'Cancelled'];
      case 'Shipped':
        return ['Delivered', 'Cancelled'];
      case 'Delivered':
        return [];
      case 'Cancelled':
        return [];
      default:
        return ['Pending', 'Confirmed', 'Processing', 'Shipped', 'Delivered', 'Cancelled'];
    }
  };
  
  // Open status update modal
  const openStatusModal = (status) => {
    setNewStatus(status);
    setStatusNote('');
    setShowStatusModal(true);
  };
  
  // Close status update modal
  const closeStatusModal = () => {
    setShowStatusModal(false);
    setNewStatus('');
    setStatusNote('');
  };
  
  // Handle Porter delivery success
  const handlePorterDeliverySuccess = async (porterOrderResult) => {
    try {
      // Update the local order state
      const updatedOrder = {
        ...order,
        porterDeliveryId: porterOrderResult.order_id,
        porterTrackingUrl: porterOrderResult.tracking_url,
        status: 'Processing', // Optionally update the order status
        statusHistory: [
          ...(order.statusHistory || []),
          {
            status: 'Processing',
            timestamp: new Date(),
            note: `Porter delivery created with ID: ${porterOrderResult.order_id}`
          }
        ]
      };
      
      // Update order in database
      await updateOrderStatus(order.id, 'Processing', {
        note: `Porter delivery created with ID: ${porterOrderResult.order_id}`,
        porterDeliveryId: porterOrderResult.order_id,
        porterTrackingUrl: porterOrderResult.tracking_url
      });
      
      // Update local state
      setOrder(updatedOrder);
      
      // Fetch Porter delivery status
      await fetchPorterDeliveryStatus(porterOrderResult.order_id);
    } catch (error) {
      console.error('Error updating order with Porter delivery:', error);
      showAlert('Order updated but failed to save Porter details', 'warning');
    }
  };
  
  // Handle status update
  const handleStatusUpdate = async () => {
    try {
      if (!order || !newStatus) return;
      
      await updateOrderStatus(order.id, newStatus, { note: statusNote });
      
      // Update order in state
      setOrder(prev => ({
        ...prev,
        status: newStatus,
        statusHistory: [
          ...(prev.statusHistory || []),
          {
            status: newStatus,
            timestamp: new Date(),
            note: statusNote
          }
        ]
      }));
      
      showAlert(`Order status updated to ${newStatus}`, 'success');
      closeStatusModal();
    } catch (error) {
      console.error('Error updating order status:', error);
      showAlert('Failed to update order status', 'error');
    }
  };
  
  // Handle invoice generation
  const handleGenerateInvoice = async () => {
    try {
      if (!order) return;
      
      setGeneratingInvoice(true);
      
      const invoice = await generateInvoice(order.id);
      
      // Update order in state
      setOrder(prev => ({
        ...prev,
        invoice
      }));
      
      showAlert('Invoice generated successfully', 'success');
      setGeneratingInvoice(false);
    } catch (error) {
      console.error('Error generating invoice:', error);
      showAlert('Failed to generate invoice', 'error');
      setGeneratingInvoice(false);
    }
  };
  
  // Refresh Porter delivery status
  const refreshPorterStatus = async () => {
    if (!order || !order.porterDeliveryId) return;
    
    await fetchPorterDeliveryStatus(order.porterDeliveryId);
    showAlert('Porter delivery status updated', 'success');
  };
  
  // Loading state
  if (loading) {
    return (
      <DashboardLayout>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600"></div>
          </div>
          <p className="text-center mt-4 text-gray-500">Loading order details...</p>
        </div>
      </DashboardLayout>
    );
  }
  
  // Error state
  if (error || !order) {
    return (
      <DashboardLayout>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="bg-red-50 border border-red-200 p-4 rounded-md">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">{error || 'Order not found'}</h3>
                <div className="mt-2 text-sm text-red-700">
                  <p>Please try again or go back to the orders page.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6">
            <Button
              type="button"
              variant="primary"
              onClick={() => navigate('/orders')}
            >
              Back to Orders
            </Button>
          </div>
        </div>
      </DashboardLayout>
    );
  }
  
  return (
    <DashboardLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Order Header */}
        <div className="sm:flex sm:items-center sm:justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Order #{order.id}
            </h1>
            <p className="mt-1 text-sm text-gray-500">
              Placed on {formatDate(order.createdAt)}
            </p>
          </div>
          <div className="mt-4 sm:mt-0 flex flex-wrap space-x-3">
            {/* Porter Dispatch Button - Only show if no Porter delivery yet */}
            {!order.porterDeliveryId && order.status !== 'Cancelled' && order.status !== 'Delivered' && (
              <PorterDispatch 
                order={order}
                onSuccess={handlePorterDeliverySuccess}
                onError={(error) => showAlert(error, 'error')}
                showAlert={showAlert}
              />
            )}
            
            {/* View Porter Tracking - Show if Porter delivery exists */}
            {order.porterTrackingUrl && (
              <Button
                type="button"
                variant="secondary"
                onClick={() => window.open(order.porterTrackingUrl, '_blank')}
              >
                <div className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                  </svg>
                  Track Porter Delivery
                </div>
              </Button>
            )}
            
            {/* Invoice Button */}
            {order.status !== 'Cancelled' && (
              <Button
                type="button"
                variant="secondary"
                onClick={handleGenerateInvoice}
                disabled={generatingInvoice || (order.status === 'Pending')}
              >
                {generatingInvoice ? (
                  <div className="flex items-center">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                    </svg>
                    Generating...
                  </div>
                ) : order.invoice ? (
                  <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z" clipRule="evenodd" />
                    </svg>
                    View Invoice
                  </div>
                ) : (
                  <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 01-1-1V8a1 1 0 112 0v3a1 1 0 01-1 1zm3-1V8a1 1 0 10-2 0v3a1 1 0 102 0zm2-3a1 1 0 011 1v3a1 1 0 11-2 0V9a1 1 0 011-1z" clipRule="evenodd" />
                    </svg>
                    Generate Invoice
                  </div>
                )}
              </Button>
            )}
            
            {/* Status Update Button */}
            {getNextStatuses(order.status).length > 0 && (
              <div className="relative">
                <select
                  className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm rounded-md"
                  value=""
                  onChange={(e) => {
                    if (e.target.value) {
                      openStatusModal(e.target.value);
                      e.target.value = '';
                    }
                  }}
                >
                  <option value="">Update Status</option>
                  {getNextStatuses(order.status).map((status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
        </div>
        
        {/* Order Status */}
        <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-6">
          <div className="px-4 py-5 sm:px-6">
            <h2 className="text-lg leading-6 font-medium text-gray-900">
              Order Status
            </h2>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              Current status and history
            </p>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:p-6">
            <div className="mb-4">
              <span className="text-sm font-medium text-gray-500">Current Status:</span>
              <div className="mt-1">
                {getStatusBadge(order.status || 'Pending')}
              </div>
            </div>
            
            {order.statusHistory && order.statusHistory.length > 0 && (
              <div>
                <h3 className="text-sm font-medium text-gray-500 mb-2">Status History:</h3>
                <div className="flow-root">
                  <ul className="-mb-8">
                    {[...order.statusHistory].reverse().map((statusChange, index) => (
                      <li key={index}>
                        <div className="relative pb-8">
                          {index !== order.statusHistory.length - 1 ? (
                            <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
                          ) : null}
                          <div className="relative flex space-x-3">
                            <div>
                              <span className="h-8 w-8 rounded-full bg-orange-500 flex items-center justify-center ring-8 ring-white">
                                <svg className="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                </svg>
                              </span>
                            </div>
                            <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                              <div>
                                <p className="text-sm text-gray-500">
                                  Status changed to <span className="font-medium text-gray-900">{statusChange.status}</span>
                                </p>
                                {statusChange.note && (
                                  <p className="mt-1 text-sm text-gray-500">
                                    Note: {statusChange.note}
                                  </p>
                                )}
                              </div>
                              <div className="text-right text-sm whitespace-nowrap text-gray-500">
                                {formatDate(statusChange.timestamp)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
        
        {/* Porter Delivery Status - Show only if Porter delivery exists */}
        {order.porterDeliveryId && (
          <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-6">
            <div className="px-4 py-5 sm:px-6 flex justify-between items-center">
              <div>
                <h2 className="text-lg leading-6 font-medium text-gray-900">
                  Porter Delivery
                </h2>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">
                  Porter delivery status and details
                </p>
              </div>
              <Button
                type="button"
                variant="secondary"
                onClick={refreshPorterStatus}
                disabled={trackingPorterDelivery}
                className="text-sm"
              >
                {trackingPorterDelivery ? (
                  <div className="flex items-center">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                    </svg>
                    Refreshing...
                  </div>
                ) : (
                  <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                    </svg>
                    Refresh Status
                  </div>
                )}
              </Button>
            </div>
            <div className="border-t border-gray-200 px-4 py-5 sm:p-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <p className="text-sm font-medium text-gray-500">Porter Order ID:</p>
                  <p className="mt-1 text-sm text-gray-900">{order.porterDeliveryId}</p>
                </div>
                
                {porterDelivery && (
                  <div>
                    <p className="text-sm font-medium text-gray-500">Current Status:</p>
                    <div className="mt-1">
                      {getPorterStatusBadge(porterDelivery.status)}
                    </div>
                  </div>
                )}
                
                {porterDelivery && porterDelivery.partner_info && (
                  <div className="sm:col-span-2">
                    <p className="text-sm font-medium text-gray-500">Delivery Partner:</p>
                    <div className="mt-2 bg-gray-50 p-4 rounded-md">
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                          <p className="text-xs text-gray-500">Name</p>
                          <p className="text-sm font-medium">{porterDelivery.partner_info.name}</p>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500">Vehicle</p>
                          <p className="text-sm font-medium">{porterDelivery.partner_info.vehicle_type} - {porterDelivery.partner_info.vehicle_number}</p>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500">Phone</p>
                          <p className="text-sm font-medium">
                            {porterDelivery.partner_info.mobile.country_code} {porterDelivery.partner_info.mobile.number}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                
                <div className="sm:col-span-2 flex justify-center">
                  <Button
                    type="button"
                    variant="secondary"
                    onClick={() => window.open(order.porterTrackingUrl, '_blank')}
                    className="mt-2"
                  >
                    <div className="flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                      </svg>
                      Open Porter Tracking Page
                    </div>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
        
        {/* Order Details */}
        <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-6">
          <div className="px-4 py-5 sm:px-6">
            <h2 className="text-lg leading-6 font-medium text-gray-900">
              Order Details
            </h2>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              Order information and summary
            </p>
          </div>
          <div className="border-t border-gray-200">
            <dl>
              <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">Order ID</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{order.id}</dd>
              </div>
              <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">Order Date</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{formatDate(order.createdAt)}</dd>
              </div>
              <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">Customer Name</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{order.customerName || 'N/A'}</dd>
              </div>
              <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">Customer Email</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{order.customerEmail || 'N/A'}</dd>
              </div>
              <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">Customer Phone</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{order.customerPhone || 'N/A'}</dd>
              </div>
              <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">Shipping Address</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {order.shippingAddress ? (
                    <div>
                      <p>{order.shippingAddress.street}</p>
                      <p>{order.shippingAddress.city}, {order.shippingAddress.state} {order.shippingAddress.zip}</p>
                      <p>{order.shippingAddress.country}</p>
                    </div>
                  ) : (
                    'N/A'
                  )}
                </dd>
              </div>
              <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">Payment Method</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{order.paymentMethod || 'N/A'}</dd>
              </div>
              {order.invoice && (
                <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">Invoice</dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    <span className="font-medium">{order.invoice.invoiceNumber}</span>
                    <span className="ml-2 text-gray-500">Generated on {formatDate(order.invoice.createdAt)}</span>
                  </dd>
                </div>
              )}
            </dl>
          </div>
        </div>
        
        {/* Order Items */}
        <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-6">
          <div className="px-4 py-5 sm:px-6">
            <h2 className="text-lg leading-6 font-medium text-gray-900">
              Order Items
            </h2>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              Products purchased in this order
            </p>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Product
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Quantity
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Price
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {order.items && order.items.length > 0 ? (
                    order.items.map((item, index) => (
                      <tr key={index}>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div className="flex-shrink-0 h-10 w-10">
                              {item.imageUrl ? (
                                <img 
                                  className="h-10 w-10 rounded-full" 
                                  src={item.imageUrl} 
                                  alt={item.name} 
                                />
                              ) : (
                                <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center">
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                  </svg>
                                </div>
                              )}
                            </div>
                            <div className="ml-4">
                              <div className="text-sm font-medium text-gray-900">
                                {item.name}
                              </div>
                              <div className="text-sm text-gray-500">
                                {item.productId}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {item.quantity}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {formatCurrency(item.price)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {formatCurrency(item.quantity * item.price)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="px-6 py-4 text-center text-sm text-gray-500">
                        No items found for this order.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            
            {/* Order Summary */}
            <div className="border-t border-gray-200 px-4 py-5">
              <div className="flex justify-end">
                <div className="w-full sm:w-1/3">
                  <div className="flex justify-between py-2">
                    <div className="text-sm text-gray-500">Subtotal</div>
                    <div className="text-sm font-medium text-gray-900">{formatCurrency(order.subtotal || 0)}</div>
                  </div>
                  <div className="flex justify-between py-2">
                    <div className="text-sm text-gray-500">Tax</div>
                    <div className="text-sm font-medium text-gray-900">{formatCurrency(order.tax || 0)}</div>
                  </div>
                  <div className="flex justify-between py-2">
                    <div className="text-sm text-gray-500">Shipping</div>
                    <div className="text-sm font-medium text-gray-900">{formatCurrency(order.shipping || 0)}</div>
                  </div>
                  <div className="flex justify-between py-2 border-t border-gray-200">
                    <div className="text-base font-medium text-gray-900">Total</div>
                    <div className="text-base font-medium text-gray-900">{formatCurrency(order.total || 0)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Back Button */}
        <div className="mt-8">
          <Button
            type="button"
            variant="secondary"
            onClick={() => navigate('/orders')}
          >
            Back to Orders
          </Button>
        </div>
      </div>
      
      {/* Status Update Modal */}
      {showStatusModal && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-orange-100 sm:mx-0 sm:h-10 sm:w-10">
                    <svg className="h-6 w-6 text-orange-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                      Update Order Status
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Update the status of order <span className="font-medium">#{order.id}</span> from <span className="font-medium">{order.status}</span> to <span className="font-medium">{newStatus}</span>.
                      </p>
                      
                      <div className="mt-4">
                        <label htmlFor="statusNote" className="block text-sm font-medium text-gray-700">
                          Add a note (optional)
                        </label>
                        <textarea
                          id="statusNote"
                          rows={3}
                          className="mt-1 block w-full shadow-sm focus:ring-orange-500 focus:border-orange-500 sm:text-sm border border-gray-300 rounded-md"
                          placeholder="Enter any additional information about this status change..."
                          value={statusNote}
                          onChange={(e) => setStatusNote(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-orange-600 text-base font-medium text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={handleStatusUpdate}
                >
                  Update Status
                </button>
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={closeStatusModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
};

export default OrderDetailsPage;